import React from 'react';
import { Button } from '@crossroads/ui-components';
import { useTranslate } from '@awardit/react-use-translate';
import styles from 'shop-views/ProceedToPayment.scss';

function _empty() {}

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

function _callIgnored(body, direct) {
  return _call(body, _empty, direct);
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var ProceedToPayment = _ref => {
  var isFree = _ref.isFree,
      isEnabled = _ref.isEnabled,
      isPending = _ref.isPending,
      setIsPending = _ref.setIsPending,
      submit = _ref.submit;
  var t = useTranslate();

  var handleSubmit = _async(function () {
    setIsPending(true);
    return _callIgnored(submit);
  });

  return /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: styles.checkoutButton,
    variant: "primary",
    loading: isPending,
    disabled: !isEnabled,
    onClick: handleSubmit
  }, isFree ? t("CHECKOUT.COMPLETE_PURCHASE") : t("CHECKOUT.TO_PAYMENT"));
};

export { ProceedToPayment };
//# sourceMappingURL=index.js.map
